export default __webpack_public_path__ + "static/media/banana.db23961c.jpg";